import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const IN_APP_HEADER_CLASS = 'inAppBrowser';
const WAIT_TIMEOUT = 500;
export function useInAppDetect() {
  const $ = _c(2);
  const [isInApp, setIsInApp] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const timeoutId = setTimeout(() => {
        const body = document.querySelector("body");
        if (body?.classList.contains(IN_APP_HEADER_CLASS)) {
          setIsInApp(true);
        }
      }, WAIT_TIMEOUT);
      return () => clearTimeout(timeoutId);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isInApp;
}